'use strict';

angular.module('internal.users')
    .controller('InternalUserInvestigations', ['$scope', 'Complaints', function ($scope, Complaints) {
        $scope.resetUser();
        $scope.vm = {
            bulkActionItems: [],
            bulkActionRunning: false
        }

        $scope.setStatus = function (bulkApply, status) {
            if (status != null && $scope.vm.bulkActionItems.length > 0) {
                $scope.vm.bulkActionRunning = true;
                Complaints.bulkAction($scope.vm.bulkActionItems, status, 'status').then(function () {
                    bulkApply.isOpen = false;
                    $scope.getUser();
                    $scope.vm.bulkActionItems.length = 0;
                    $scope.vm.bulkActionRunning = false;
                    window.location.reload();
                })
            }
        }

        $scope.bulkActions = [
            {
                action: $scope.setStatus,
                service: 'ComplaintStatuses'
            }
        ]
    }])
;